import request from '@/utils/request'

// 查询商家充值管理列表
export function listRecharge(data) {
    return request({
        url: '/money/recharge/list',
        method: 'get',
        params: data
    })
}

// 充值保存
export function saveRecharge(data) {
  return request({
    url: '/money/recharge/save',
    method: 'post',
    data: data
  })
}

// 查询商家提现管理列表
export function listWithdraw(data) {
  return request({
      url: '/money/withdraw/list',
      method: 'get',
      params: data
  })
}

// 提交提现申请
export function saveWithdraw(data) {
  return request({
    url: '/money/withdraw/save',
    method: 'post',
    data: data
  })
}